import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

// PortalLogin now redirects to unified login - all users (admin, worker, client) 
// use the same login system at /login
export const PortalLogin = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Clear any old tokens and redirect to unified login
    localStorage.removeItem('portal_token');
    localStorage.removeItem('portal_user');
    localStorage.removeItem('worker_token');
    localStorage.removeItem('client_token');
    localStorage.removeItem('admin_token');
    navigate('/login', { replace: true });
  }, [navigate]);

  // Show loading while redirecting
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 flex items-center justify-center px-4">
      <div className="text-center">
        <Loader2 className="w-12 h-12 text-[#f47c2a] mx-auto mb-4 animate-spin" />
        <p className="text-[#1D1D1F] text-lg">Redirigiendo al login...</p>
      </div>
    </div>
  );
};
